import React, { FC } from 'react';

import { IconPropsExtended } from '../types';

import MaterialSymbolIconBase from './MaterialSymbolIconBase';

/**
 * Material symbol clock alt outlined icon
 *
 * @param props Props passed to the component
 * @returns     Clock Alt icon
 */
const MaterialSymbolClockAltIcon: FC<IconPropsExtended> = props => (
  <MaterialSymbolIconBase {...props} iconName="clockAlt" />
);

export default MaterialSymbolClockAltIcon;
